import { useTranslation } from 'react-i18next';
import { Grid } from '@shared/ui';

import { SectionHeader } from './SectionHeader';
import { AspectRatioShowcase } from './layout/AspectRatioShowcase';
import { CardShowcase } from './layout/CardShowcase';
import { ContainerShowcase } from './layout/ContainerShowcase';
import { GridShowcase } from './layout/GridShowcase';
import { StackShowcase } from './layout/StackShowcase';

export function LayoutSection() {
  const { t } = useTranslation();

  return (
    <section id="layout" className="space-y-6">
      <SectionHeader
        title={t('uiLibrary.layout.title')}
        description={t('uiLibrary.layout.description')}
      />

      <Grid cols={1} gap="lg" className="lg:grid-cols-2">
        <CardShowcase />
        <ContainerShowcase />
        <StackShowcase />
        <GridShowcase />
        <div className="lg:col-span-2">
          <AspectRatioShowcase />
        </div>
      </Grid>
    </section>
  );
}
